export const vendorCurrency = {
  aws: 'usd',
  azure: 'usd',
  gcp: 'jpy',
};
